module.exports = __webpack_public_path__ + "img/Group 1504775755.10273b85.svg";